import clsx from "clsx";
import { StepperIndicator } from "./StepperIndicator";
import { StepperHeader } from "./StepperHeader";
import { StepperNavigationButtons } from "./StepperNavigationButtons";
import { StepperProps } from ".";

export function StepperMobile({
  classNames,
  currentStep,
  isDisabled = false,
  nextButtonLabel = "Next",
  onNext,
  onPrevious,
  previousButtonLabel = "Previous",
  showStepIndicator = true,
  steps,
}: StepperProps) {
  if (steps.length === 0) {
    return <div>No steps provided</div>;
  }

  const isFirstStep = currentStep === 0;
  const step = steps[currentStep];

  const handleNext = () => {
    onNext();
  };

  return (
    <div className="flex h-full w-full flex-col justify-between overflow-hidden">
      <div className={clsx("flex-shrink-0", classNames?.content)}>
        <div className="mb-4">
          {showStepIndicator && <StepperIndicator currentStep={currentStep} totalSteps={steps.length} />}

          <StepperHeader title={step.title} description={step.description} badge={step.badge} />
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto px-4 py-2">
        {step.content}
      </div>
      {/* Navigation Buttons */}
      <div className="flex-shrink-0">
        <StepperNavigationButtons
          isDisabled={isDisabled}
          isFirstStep={isFirstStep}
          onNext={handleNext}
          onPrevious={onPrevious}
          nextButtonLabel={nextButtonLabel}
          previousButtonLabel={previousButtonLabel}
          classNames={classNames?.navigationButtons}
        />
      </div>
    </div>
  );
}
